import { useState, useCallback } from "react";
import { MultiSelectDropDown, DateInput, Button } from "@/components";
import { SpaceWrapper } from "../../components";
import { useApi } from "@/";
import { subDays } from "date-fns";
const Reports = () => {
  const currentDate = new Date();
  const startOfMonthDate = subDays(currentDate, 30); // Last 30 days
  const endOfMonthDate = new Date(currentDate);
  const [reportType, setReportType] = useState([]);
  const [dateRange, setDateRange] = useState({
    from: startOfMonthDate,
    to: endOfMonthDate,
  });
  const { callApi } = useApi();

  const handleGenerateReport = useCallback(async () => {
    console.log("Generating Report:", { reportType, dateRange });

    // Validate inputs before making the API call
    if (reportType?.length <= 0) {
      alert("Please select a report type");
      return;
    }

    if (!dateRange || !dateRange.from || !dateRange.to) {
      alert("Please select a valid date range");
      return;
    }
    const filename = `${reportType}_${new Date().getTime()}`;

    // Format the date range properly for the API
    const response = await callApi(
      "/common/export",
      "POST",
      {
        model: "Admin Reports",
        ids: [reportType.join(","), ...Object.values(dateRange)],
        filename,
      },
      null,
      null,
      "blob"
    );

    const contentType = response?.headers?.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const errorData = await response.json();
      console.error("Export failed:", errorData.message);
      return; // Exit early
    }

    // Proceed with blob handling if not JSON
    const blob = new Blob([response], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 100);
  }, [reportType, dateRange]);

  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <h2 className="text-headline3 lg:text-headline2 font-nunito font-bold text-secondary/95">
          Generate Reports
        </h2>

        <div className="flex flex-col md:flex-row gap-2 md:gap-4 items-center">
          <MultiSelectDropDown
            label="Report Type"
            placeholder="Select Report Type"
            options={[
              { value: "Booked Order", label: "Booked Order" },
              { value: "Shipped Order", label: "Shipped Order" },
              { value: "Weight Dispute", label: "Weight Dispute" },
              { value: "Shipping Charges", label: "Shipping Charges" },
              { value: "NDR", label: "NDR" },
              { value: "Customer", label: "Customer" },
            ]}
            values={reportType} // Correctly handling multiple selections
            onChange={setReportType} // Updates the state correctly
          />
          <DateInput
            label="Date Range"
            placeholder="Select From & To date"
            mode="range"
            value={dateRange}
            onChange={setDateRange}
          />
          <div className="flex w-full pt-5 justify-end md:justify-start">
            <Button
              variant="default"
              size="md"
              onClick={handleGenerateReport}
              className="h-12"
            >
              Generate Report
            </Button>
          </div>
        </div>
      </div>
    </SpaceWrapper>
  );
};

export default Reports;
